import { Pipe, PipeTransform } from '@angular/core';
import { CodeType } from '../enums/code-type';

@Pipe({
  name: 'mapToColorClass',
  standalone: true,
})
export class MapToColorClassPipe implements PipeTransform {
  transform(type: CodeType): string {
    return type.split(' ')[1].toLowerCase() ?? 'yellow';
  }
}
